const navigationSchema = [
  { title: "Find your clinic", path: "/find-your-clinic" },
  { title: "Understand fertility", path: "/understand-fertility" },
];

export default navigationSchema;

export const navigationSchemaWithHome = [
  {
    title: "Home",
    path: "/",
  },
].concat(navigationSchema); // For mobile nav
